import { FiDate } from '@treasury/domain/dates';
import { formatUsdCurrency } from '@treasury/utils/functions/currency.helpers';
import { format } from 'date-fns';
import { AchPayment } from '../types/ach-payment.type';

export type AchPaymentViewModel = {
    status: string;
    transactionId: string;
    name: string;
    creditAmount: string;
    debitAmount: string;
    paymentDate: string;
    frequencyDisplay: string;
    id: number;
    permissions?: string[];
    fileName: string | null;
    achCompanyName: string;
    secCode: string;
    createdDate: string;
};

export class AchPaymentTableViewModel {
    constructor(private readonly dto: AchPayment) {}

    public status = this.dto.status;

    public transactionId = this.dto.transactionId;

    public name = this.dto.name;

    public fileName = this.dto.fileName || '';

    public achCompanyName = this.dto.companyName;

    public secCode = this.dto.secCode;

    public creditAmount = formatUsdCurrency(this.dto.creditAmount);

    public debitAmount = formatUsdCurrency(this.dto.debitAmount);

    public paymentDate = format(new FiDate(this.dto.frequency.effectiveDate).date, 'P');

    public createdDate = format(new FiDate(this.dto.createdDate).date, 'P');

    public frequencyDisplay = `${this.dto.frequency.type} (${this.paymentDate})`;

    public id = this.dto.id;

    public permissions = this.dto.permissions?.map((p: { permission: string }) => p.permission);
}
